// Send Logs' redactor (docs/features/send-logs.md › Redaction): what scrubs a bundle before it leaves this device.
// The rules are tools/tests/redact-vectors.json's, in its order, written out as JS — that file is the one list, the
// Android client's LogRedactor.kt is held to the same cases, and tools/tests/web-sendlogs.mjs checks every pattern
// here is the file's, character for character.

export const REDACTED = '[redacted]'

export const RULES = [
  // a link's fragment (a pairing link's room and key ride there)
  ['fragment', /\b((?:https?|cody(?:-dev)?):\/\/[^\s#"'<>]*)#[^\s"'<>]+/g, '$1#[redacted]'],
  // a secret in a query
  ['query', /([?&](?:token|key|code|ticket|sig|signature|password|pass|secret|auth|session|t|k)=)[^&\s#"'<>]+/gi, '$1[redacted]'],
  // Bearer / Basic / Token credentials
  ['scheme', /\b(Bearer|Basic|Token)\s+[A-Za-z0-9._~+/=-]{8,}/gi, '$1 [redacted]'],
  // password=, token:, …Key=, code:, pin= — the key stays, a value of four or more characters goes
  ['named', /(["']?\b(?:[A-Za-z_-]*(?:password|passwd|passphrase|secret|token|key|authorization|cookie|ticket|signature)|code|pin|sig)["']?\s*[:=]\s*["']?)([^\s"',;&}]{4,})/gi, '$1[redacted]'],
  // "code ABC-123" in words
  ['codePhrase', /\b(code|Code|CODE|pin|Pin|PIN)(:?\s+)([A-Z0-9]{3}-?[A-Z0-9]{3})\b/g, '$1$2[redacted]'],
  ['jwt', /\beyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/g, '[redacted]'],
  // known API-key prefixes
  ['prefixed', /\b(?:sk-[A-Za-z0-9_-]{16,}|sk_(?:live|test)_[A-Za-z0-9]{16,}|ghp_[A-Za-z0-9]{20,}|github_pat_[A-Za-z0-9_]{20,}|xox[abprs]-[A-Za-z0-9-]{10,}|rg_[A-Za-z0-9_-]{16,}|AKIA[0-9A-Z]{16})/g, '[redacted]'],
  // any opaque run of 32 or more: only with a digit and a letter, and never a UUID
  ['opaque', /[A-Za-z0-9_+=-]{32,}/g, (run) => (/\d/.test(run) && /[A-Za-z]/.test(run) && !UUID.test(run) ? REDACTED : run)],
]
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/// `text` with every secret the rules know replaced by "[redacted]".
export function redact(text) {
  let out = String(text ?? '')
  for (const [, pattern, replace] of RULES) out = out.replace(pattern, replace)
  return out
}
